// ----------------------  accordion on Collection page --------------
document.addEventListener('DOMContentLoaded', function () {
    if (window.location.href.includes('/collection')) {
        const triggers = document.querySelectorAll('.collection-hero__description .returnAccord-block_triggr');
        triggers.forEach(function (trigger) {
            trigger.addEventListener('click', function (e) {
                e.preventDefault();
                const content = this.nextElementSibling;
                if (content.classList.contains('show')) {
                    content.classList.remove('show');
                    this.classList.add('collapsed');
                } else {
                    content.classList.add('show');
                    this.classList.remove('collapsed');
                }
            });
        });
    }
});